import { type BEResponseProcedimentoConTaskData } from '@framework/api-client/api/backoffice/schemas/bEResponseProcedimentoConTaskData.ts';
import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import type React from 'react';
import { DossierApplicantTableCell } from '../../schema/dossiers/table/applicant/DossierApplicantTableCell.tsx';

export interface IDescriptionsItem {
  label?: React.ReactNode;
  children?: React.ReactNode;
  span?: number;
  excludeBackoffice?: boolean;
  excludeFrontoffice?: boolean;
}

/**
 * Trasforma i dati del procedimento in un array di oggetti per la descrizione
 */
export const procedureToDescriptionsItems = (
  procedure?: ProcedimentoConTask | BEResponseProcedimentoConTaskData | null,
): IDescriptionsItem[] => {
  if (!procedure) return [];

  const items: IDescriptionsItem[] = [
    { label: 'Numero pratica', children: procedure.numero },
    { label: 'Oggetto pratica', children: procedure.oggetto, span: 2 },
    {
      label: 'Tipo pratica',
      excludeBackoffice: true,
      children: procedure.pratica?.tipoPratica?.denominazioneTipoProcedimento,
    },
    {
      label: 'Fase corrente',
      excludeBackoffice: true,
      children: procedure.nomeFaseCorrente,
    },
    { label: 'Stato', children: procedure.pratica?.stato },
    {
      label: 'Data avvio',
      excludeBackoffice: true,
      children: (
        <ISODate
          date={procedure.dataAvvio}
          format="DD/MM/YYYY HH:mm"
          parseFormat="DD/MM/YYYY HH:mm:ss"
        />
      ),
    },
    {
      label: 'Tipo domanda di avvio',
      children: procedure.pratica?.richiestaAvvio?.tipoDomanda?.titolo,
    },
    {
      label: 'Numero richiesta di avvio',
      children: procedure.pratica?.richiestaAvvio?.numero,
    },

    // {
    //   label: 'Richiedente',
    //   children:
    //     procedure.nomeUtenteAvvio + ' (' + procedure.cfUtenteAvvio + ')',
    // },
    // { label: 'Ufficio di avvio', children: procedure.nomeUfficioAvvio },
    {
      label: 'Ufficio competente',
      children: procedure.nomeUfficioCompetente,
    },
    {
      label: 'Procedimento di Avvio',
      children:
        procedure.pratica?.procedimentoAvvio?.tipoProcedimento?.denominazione,
    },
    {
      label: 'Numero Procedimento di Avvio',
      children: procedure.pratica?.procedimentoAvvio?.numero,
    },
    {
      label: 'Titolare Pratica',
      children: (
        <DossierApplicantTableCell
          applicants={procedure.pratica?.personeFisiche}
        />
      ),
    },
  ];
  return items;
};
